import React from 'react';
import { DELIMITER, COLOR, KEY_VALUES } from "../../modules/constants"
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { withStyles } from '@mui/styles';
import { Checkbox, Box, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from "@mui/material"

const styles = theme => ({
  text: {
    whiteSpace: "pre-wrap",
    color: "black",
  },
  warningText: {
    whiteSpace: "pre-wrap",
    color: COLOR.BAD,
  },
});

const ExportCsvModal = ({ classes, rowCount, open, onClose, onSubmit, title }) => {
  const warning = rowCount > KEY_VALUES.MAX_CSV_ROWS

  const centre = warning
    ? `NB: You are trying to export ${rowCount} items, but Numerable only exports the first ${KEY_VALUES.MAX_CSV_ROWS}. Consider using filters to narrow down the results.`
    : `Export ${rowCount} items?`

  const [includeCheckboxSettingsChecked, setIncludeSettingsChecked] = React.useState(true);
  const [delimiterValue, setDelimiterValue] = React.useState("comma")

  // const handleRadioButtonChange = event => setRadioValue(event.target.value)
  // const handleCheckboxChange = event => setChecked(event.target.checked)

  return (<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText className={warning ? classes.warningText : classes.text} >
        {centre}
      </DialogContentText>

      {/* <Box display="flex" alignItems="center">

        <FormLabel component="legend" sx={{ marginRight: 1 }}>
          Delimiter:
        </FormLabel>

        <RadioGroup
          row
          value={radioValue}
          onChange={(e) => setRadioValue(e.target.value)}
        >
          <FormControlLabel value="comma" control={<Radio onChange={handleRadioButtonChange} />} label="comma" />
          <FormControlLabel value="tab" control={<Radio onChange={handleRadioButtonChange} />} label="tab" />
        </RadioGroup>
      </Box> */}

      <Box display="flex" alignItems="center" justifyContent="space-between">

        {/* <Box display="flex" alignItems="center">
          <FormLabel sx={{ marginRight: 2 }}>Delemiter:</FormLabel>
          <RadioGroup
            row
            value={delimiterValue}
            onChange={(e) => setDelimiterValue(e.target.value)}
          >
            <FormControlLabel value="comma" control={<Radio />} label={DELIMITER.COMMA} />
            <FormControlLabel value="tab" control={<Radio />} label={DELIMITER.TAB} />
          </RadioGroup>
        </Box> */}

        <FormControlLabel
          control={
            <Checkbox
              checked={includeCheckboxSettingsChecked}
              onChange={(e) => setIncludeSettingsChecked(e.target.checked)}
            />
          }
          label=" Include details and settings"
        // labelPlacement="start"
        />
      </Box>

    </DialogContent>

    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={() => onSubmit({ includeSettingsChecked: includeCheckboxSettingsChecked, delimiterValue })} color="primary">
        Continue
      </Button>
    </DialogActions>
  </Dialog>
  )
}

export default withStyles(styles)(ExportCsvModal)

